
const ceecampaign = {
  general: {
    name: "Nom",
    groups: "Périmètre",
    status: "Statut de la campagne",
    datebegin: "Date de début",
    dateend: "Date de fin",
    associateddocuments: "Pièces associées",
    otherfiles: "Autres fichiers associés",
  },
  provider: {
    name: "Fournisseur",
    inchargename: "Nom du responsable",
    address: "Adresse postale",
    phone: "Numéro de téléphone",
    email: "Adresse email",
    requestemail: "Adresse email - Demandes",
    contactname: "Nom du contact",
    contactfunction : "Rôle"
  },
  ceecampaignresponsible: {
    name: "Entité responsable de la campagne",
    inchargeuser: "Responsable de la campagne",
    inchargename: "Nom du responsable",
    address: "Adresse postale",
    phone: "Numéro de téléphone",
    email: "Adresse email",
    requestemail: "Adresse email secondaire",
  },
  membershipcount : "Nombre de membres"
};

const memberships = {
  name: "Nom du membre",
  internalmembershipnumber: "Numéro interne",
  contactname: "Nom du contact principal",
  contactjob: "Poste / Fonction",
  company: "Structure / Société",
  siret: "Code SIRET",
  phone: "Téléphone",
  email: "Email",
  address: "Adresse",
  comments: "Commentaires",
  associatedfiles: "Fichiers associés",
  description: "Description",
  groups: "Périmètre",
}

const ceecampaignfiles = {
  doctype: "Type de document",
  docname: "Nom du document",
  associatedfiles: "Document associé",
  description: "Description"
}

const ceecase = {
  name: "Nom du dossier",
  groups: "Périmètre",
  ceeform: "Fiche CEE",
  kwhcumac: "kWh cumac",
  description: "Description",
  status: "Statut",
  ceecampaignmembershipname: "Nom du membre",
  ceecampaignmembershipaddress: "Adresse de l'adhérent",
  ceecampaignmembershipsiret: "SIRET de l'adhérent",
  author: "Nom du créateur du dossier",
  inchargeuser: "Responsable du dossier",
  referentname: "Nom du responsable du dossier",
  referentemail: "Adresse mail du responsable du dossier",
  referentphone: "Téléphone du responsable du dossier",
  comments: "Commentaires",
  executiondate: "Date de réalisation souhaitée",
  creationdate: "Date de création",
  validationdate: "Date de soumission",
}

const ceecasefile = {
  doctype: "Type de document",
  docname: "Nom du document",
  associatedfiles: "Document exemple",
  fillassociatedfiles: "Document complété",
  status: "Statut",
  comments: "Commentaires",
  validationdate: "Date de validation",
}

const ceenotification = {
  recipienttype: "Destinataires",
  title: "Sujet",
  message: "Message",
}

export { ceecampaign, memberships, ceecampaignfiles, ceecase, ceecasefile, ceenotification };
